exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pipe[data-v-3bb15902]{position:fixed;right:50vw;height:200vh}.pipe .bottom[data-v-3bb15902],.pipe .top[data-v-3bb15902]{display:block;width:38px;height:100vh}.pipe .bottom .body[data-v-3bb15902],.pipe .top .body[data-v-3bb15902]{width:30px;height:calc(100vh - 17px)}.pipe .top[data-v-3bb15902]{position:relative;top:calc(-50vh - 50px)}.pipe .top .body[data-v-3bb15902]{position:absolute;top:0;left:4px}.pipe .top .head[data-v-3bb15902]{position:absolute;bottom:4px}.pipe .bottom[data-v-3bb15902]{position:relative;top:calc(-50vh + 50px)}.pipe .bottom .body[data-v-3bb15902]{position:absolute;bottom:0;left:4px}.pipe .bottom .head[data-v-3bb15902]{position:absolute;top:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bb15902","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/objects/game/Pipe.vue
// module id = 57
// module chunks = 0